(function () {
    'use strict';

    require('./app.require.js');

    angular.module('appTherapist', ['vcRecaptcha',
        /*
         * Everybody has access to these.
         * We could place these under every feature area,
         * but this is easier to maintain.
         */
        'app.core',
        'app.data', // needs core
        'app.widgets', // needs core
        /*SHELL*/
        'app.layout',
        'app.login',
        'app.language',
        'app.booking'
        /* features*/
        //'app.association',
        //'app.therapistMaster',
        //'app.therapist',
        //'app.clinicMaster',
        //'app.clinic',

        //'app.preference',
        //'app.dynamic',
        //'app.advisor',
        //'app.formly'
    ]);

    require('./app.therapist.config.js');
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/app.therapist.module.js
 ** module id = 273
 ** module chunks = 0
 **/